var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KvTable',{staticClass:"search_box",attrs:{"items":_vm.items},on:{"click":function($event){return _vm.$modal.hide('notification-modal')}}}),_c('img',{attrs:{"src":"/images/ic/comm/ic-search.svg","alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }